function pluralize(count: number, forms: [string, string, string]): string {
    const n = Math.abs(count) % 100;
    const n1 = n % 10;

    if (n > 10 && n < 20) return forms[2];
    if (n1 > 1 && n1 < 5) return forms[1];
    if (n1 === 1) return forms[0];
    return forms[2];
}

/**
 * Форматирование времени события
 * @param timestamp - timestamp события в секундах
 * @returns 
 */
export function formatEventTime(timestamp: number): string {
    const eventDate = new Date(timestamp * 1000);
    const now = new Date();

    // Вычисляем разницу во времени
    const diffMs = now.getTime() - eventDate.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMinutes < 1) {
        return 'только что';
    } else if (diffMinutes < 60) {
        const minuteWord = pluralize(diffMinutes, ['минуту', 'минуты', 'минут']);
        return `${diffMinutes} ${minuteWord} назад`;
    } else if (diffHours < 24) {
        const remainingMinutes = diffMinutes % 60;
        const hourWord = pluralize(diffHours, ['час', 'часа', 'часов']);

        if (remainingMinutes === 0) {
            return `${diffHours} ${hourWord} назад`;
        } else {
            const minuteWord = pluralize(remainingMinutes, ['мин.', 'мин.', 'мин.']);
            return `${diffHours} ${hourWord} и ${remainingMinutes} ${minuteWord} назад`;
        }
    } else {
        const dayWord = pluralize(diffDays, ['день', 'дня', 'дней']);
        return `${diffDays} ${dayWord} назад`;
    }
}

export function calculateMarkerOpacity(timestamp: number): number {
    const now = Math.floor(Date.now() / 1000);
    const diffMinutes = Math.floor((now - timestamp) / 60);

    if (diffMinutes >= 120) return 0.0; // старше 2 часов - скрываем полностью
    if (diffMinutes <= 0) return 1.0;   // новая - полная видимость
    
    // Линейная прозрачность от 1.0 до 0.0 за 120 минут (2 часа)
    return 1.0 - (diffMinutes / 240);
}